















import { defineComponent, PropType } from '@vue/composition-api'
import { CatalogItem } from '@/store/socialStream/postApiRequestHelper'
import ProductRow from '@/views/components/socialStream/ProductRow.vue'
import ProductsFromCatalogStore from '@/store/productsList/productsFromCatalog'
import PaginationPostList from '@/views/components/socialStream/PaginationPostList.vue'

export default defineComponent({
  name: 'ProductsByRowList',
  components: { PaginationPostList, ProductRow },
  props: ['products', 'linkedProductsIds', 'linkItemFn', 'detachItemFn'],
  computed: {
  },
})
